var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"modal"}},[(_vm.isShow)?_c('CModal',{staticClass:"modal-kaggle",on:{"closeModal":function($event){return _vm.$emit('closeModal')}}},[_c('div',{staticClass:"modal-kaggle__content"},[_vm._t("default")],2)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }